var _a;
import { CardType } from "../../data";
import { mapSelectionNames } from "../mapSelectionNames";
import { mapMarketName } from "../mapMarketName";
var HeaderNamesMapper = (_a = {},
    _a[CardType.Multiview] = function (market, dict, sportId, isMainHeading) {
        return isMainHeading
            ? mapMarketName(market, dict, sportId)
            : mapSelectionNames(market, dict);
    },
    _a[CardType.American] = function (market, dict, sportId) { return mapMarketName(market, dict, sportId); },
    _a);
export var getHeaderNames = function (config, dict, sportId, isMainHeading) {
    if (isMainHeading === void 0) { isMainHeading = false; }
    var marketsNames = HeaderNamesMapper[config.cardType]
        ? config
            .markets
            .map(function (market) { return HeaderNamesMapper[config.cardType](market, dict, sportId, isMainHeading); })
        : [];
    return marketsNames;
};
//# sourceMappingURL=getHeaderNames.js.map